var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8438 26.6544L18.6461 27.7811V26.2994L18.3115 25.9599H15.9085V27.6885V28.9077H18.4788L21.6422 27.5187L22.8438 26.6544Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15598 26.6544L13.2624 27.7811V26.2994L13.6122 25.9599H16V27.6885V28.9077H13.4297L10.2662 27.5187L9.15598 26.6544Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3119 23.4437L18.6465 26.299L18.2206 25.9594H13.7796L13.2625 26.299L13.6123 23.4437L14.2967 23.0116L17.7187 23.0888L18.3119 23.4437Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.624 4.07416L18.5708 8.93578L17.6279 23.0885H14.2971L13.2629 8.93578L11.377 4.07416H20.624Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.597 14.7547L32 21.7924L26.0077 21.4375H22.1598V18.397L22.3271 12.1618L23.194 12.8409L29.597 14.7547Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0635 15.5419L18.0522 15.7116L18.8278 19.354L22.1586 18.4897L25.0635 15.5419Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0635 15.6188L22.1586 18.3968V21.1749L25.0635 15.6188Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1592 18.4891L18.7372 19.3534L17.6269 23.0884L18.4026 23.5205L22.1592 21.2672V18.4891Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1593 21.2678L22.8438 26.6542L18.3115 23.444L22.1593 21.2678Z",
    fill: "#EB8F35"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0554 15.7115L17.63 23.0888L18.9062 19.323L18.0554 15.7115Z",
    fill: "#EA8E3A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0996 21.3604L22.1605 21.2678L22.8449 26.6542L26.0996 21.3604Z",
    fill: "#D87C30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1141 29L22.8442 26.6541L26.0989 21.3603L32 21.7924L30.1141 29Z",
    fill: "#EB8F35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5693 8.9361L22.2498 12.0691L25.0635 15.5417L18.0522 15.8041L18.5693 8.9361Z",
    fill: "#E8821E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8438 26.6541L18.3115 23.4438L18.6461 26.2219V27.7807L21.7335 27.1788L22.8438 26.6541Z",
    fill: "#DFCEC3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15609 26.6541L13.6123 23.4438L13.2625 26.2219V27.7807L10.1903 27.1788L9.15609 26.6541Z",
    fill: "#DFCEC3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9403 17.2701L18.9974 19.2765L22.3281 18.3967L19.9403 17.2701Z",
    fill: "#393939"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2073 0L18.5724 8.93613L20.5344 4.0745L30.2073 0Z",
    fill: "#E88F35"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2054 0L31.7415 4.76902L30.8898 9.98562L31.4829 10.3252L30.6312 11.1123L31.3156 11.7142L30.3727 12.5785L30.9658 13.1032L29.597 14.8318L23.1788 12.8409C20.0458 10.2943 18.4945 8.99786 18.5553 8.93613C18.6161 8.87439 22.5096 5.89568 30.2054 0Z",
    fill: "#8E5A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40301 14.7547L0 21.7924L5.99232 21.4375H9.84019V18.397L9.67289 12.1618L8.82119 12.8409L2.40301 14.7547Z",
    fill: "#F89D35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93652 15.5419L13.9478 15.7116L13.1874 19.354L9.84143 18.4897L6.93652 15.5419Z",
    fill: "#D87C30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93652 15.6188L9.84143 18.3968V21.1749L6.93652 15.6188Z",
    fill: "#EA8D3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84082 18.4891L13.2628 19.3534L14.3731 23.0884L13.6126 23.5205L9.84082 21.2672V18.4891Z",
    fill: "#F89D35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84065 21.2678L9.15625 26.6542L13.6125 23.5211L9.84065 21.2678Z",
    fill: "#EB8F35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9456 15.7115L14.371 23.0888L13.0947 19.323L13.9456 15.7115Z",
    fill: "#EA8E3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90234 21.3604L9.84146 21.2678L9.15706 26.6542L5.90234 21.3604Z",
    fill: "#D87C30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88591 29L9.15578 26.6541L5.90107 21.3603L0 21.7924L1.88591 29Z",
    fill: "#EB8F35"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4307 8.9361L9.75018 12.0691L6.93652 15.5417L13.9478 15.8041L13.4307 8.9361Z",
    fill: "#E8821E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0607 17.2701L13.0036 19.2765L9.67285 18.3967L12.0607 17.2701Z",
    fill: "#393939"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79541 0L13.4302 8.93613L11.4683 4.0745L1.79541 0Z",
    fill: "#E88F35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79465 0L0.258545 4.76902L1.11025 9.98562L0.517097 10.3252L1.3688 11.1123L0.684395 11.7142L1.62735 12.5785L1.0342 13.1032L2.40301 14.8318L8.82118 12.8409C11.9542 10.2943 13.5055 8.99786 13.4447 8.93613C13.3839 8.87439 9.50558 5.89568 1.79465 0Z",
    fill: "#8E5A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.0f6f307322f992ad7e3fbc0f3b91bd12.svg";
export { ForwardRef as ReactComponent };